import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchMenuData } from '../services/menuService';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const HomePage = () => {
  const [menuData, setMenuData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const categories = Object.values(menuData);
  const [containerRef, isIntersecting] = useIntersectionObserver();
  
  // Check if device is mobile for reduced animation delays
  const isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const animationDelay = isMobile ? 0.05 : 0.1;

  useEffect(() => {
    const loadMenuData = async () => {
      try {
        setLoading(true);
        const data = await fetchMenuData();
        setMenuData(data);
        setError(null);
      } catch (err) {
        console.error('Failed to load menu data:', err);
        setError('Failed to load menu. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    loadMenuData();
  }, []);

  if (loading) {
    return (
      <div className="home-page" ref={containerRef}>
        <div className="loading-message">Loading menu...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="home-page" ref={containerRef}>
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className={`home-page ${isIntersecting ? 'fade-in-active' : ''}`} ref={containerRef}>
      <div className="categories-grid">
        {categories.map((category, index) => (
          <Link 
            key={category.id} 
            to={`/category/${category.id}`} 
            className={`category-card ${isIntersecting ? 'fade-in-up-active' : ''}`}
            style={{ animationDelay: `${(index + 1) * animationDelay}s` }}
          >
            <div className="category-title">{category.name}</div>
            {/* <div className="category-description">{category.description}</div> */}
            <div className="category-count">{category.items.length} items</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default HomePage;
